import React from 'react';
import CustomTable from '../table/table';
import { toUSD } from 'src/util/currency-formatter';
import idx from 'idx';
import { round } from 'lodash';

const ClaimHistoryTable = ({ invoiceAndProgressCLaim = [] }) => {
    const claims = Array.isArray(invoiceAndProgressCLaim) ? invoiceAndProgressCLaim : [];
    const maxInvoiceIdDigits = claims.length > 0 ? Math.max(...claims.map(claim => claim?.invoice?.id?.toString().length || 0)) : 0;
    const desiredLength = Math.max(maxInvoiceIdDigits, 4);

    const formatInvoiceNumber = (invoiceId) => {
        if (!invoiceId) return 'INV-0000';
        const paddedId = invoiceId.toString().padStart(desiredLength, '0');
        return `INV-${paddedId}`;
    };

    const calculateRevisedContractPrice = (claim) => {
        return ((claim?.contractPrice || 0) + (claim?.variation || 0));
    };

    const calculatePreviousClaim = (currentIndex) => {
        let totalClaimAmount = 0, totalRetention = 0;
        for (let i = 0; i <= currentIndex; i++) {
            totalClaimAmount += idx(claims, _ => _[i].claimAmount) || 0;
            totalRetention += idx(claims, _ => _[i].retentionAmount) || 0 - idx(claims, _ => _[i].retentionClaimAmount) || 0;
        }
        return { totalClaimAmount, totalRetention };
    };

    const calculateContractBalance = (revisedContractPrice, totalClaimAmount, totalRetention) => {
        return round(revisedContractPrice - parseFloat(totalClaimAmount) + parseFloat(totalRetention), 2);
    };


    const tableData = claims.map((claim, index) => {
        const revisedContractPrice = round(calculateRevisedContractPrice(claim), 2);
        const { totalClaimAmount, totalRetention } = calculatePreviousClaim(index);
        const currentClaim = round(claim.claimAmount || 0, 2);
        const totalClaimed = round(totalClaimAmount, 2);
        const contractBalance = calculateContractBalance(
            revisedContractPrice,
            totalClaimed,
            totalRetention
        );
        const invoiceDate = new Date(claim.invoiceDate).toISOString().split('T')[0];
        const invoiceNumber = formatInvoiceNumber(idx(claim, _ => _.invoice.id));

        return {
            id: claim.id || index,
            date: invoiceDate,
            invoiceNumber: invoiceNumber,
            revisedContractPrice: toUSD(revisedContractPrice),
            totalClaimAmount: toUSD(totalClaimed),
            currentClaim: toUSD(currentClaim),
            contractBalance: toUSD(contractBalance),
        };
    });


    // Define the columns for CustomTable
    const columns = [
        {
            title: 'Date',
            field: 'date',
            class: 'text-left',
            render: row => row.date,
        },
        {
            title: 'Invoice Number',
            field: 'invoiceNumber',
            class: 'text-left',
            render: row => row.invoiceNumber,
        },
        {
            title: 'Revised Contract Price',
            field: 'revisedContractPrice',
            class: 'text-right',
            render: row => row.revisedContractPrice,
        },
        {
            title: 'Current Claim',
            field: 'currentClaim',
            class: 'text-right',
            render: row => row.currentClaim,
        },
        {
            title: 'Total Claimed Amount',
            field: 'totalClaimAmount',
            class: 'text-right',
            render: row => row.totalClaimAmount,
        },
        {
            title: 'Contract Balance',
            field: 'contractBalance',
            class: 'text-right',
            render: row => row.contractBalance,
        },
    ];

    return (
        <>
            <h5 className='position-absolute m-0 brand-color-1 claim-history'>Claims History</h5>
            <CustomTable
                columns={columns}
                data={tableData}
                exportButton={true}
                toolbar={true}
                fileName="claim-history"
                paginationCount={tableData.length}
                stickyHeader={true}
            />
        </>
    );
};

export default ClaimHistoryTable;